// Lightweight in-app (foreground) OS notifications. No backend push / service
// worker push — these only fire while the app is open, driven by the existing
// pollers (book-closing status & capital requests).
const MUTE_KEY = "emc_notif_muted";

export function canNotify() {
  return typeof window !== "undefined" && "Notification" in window;
}

export function notifPermission() {
  return canNotify() ? Notification.permission : "denied";
}

export async function requestNotifyPermission() {
  if (!canNotify()) return "denied";
  try { return await Notification.requestPermission(); } catch { return "denied"; }
}

export function isNotifMuted() {
  try { return localStorage.getItem(MUTE_KEY) === "1"; } catch { return false; }
}

export function setNotifMuted(muted) {
  try { localStorage.setItem(MUTE_KEY, muted ? "1" : "0"); } catch { /* ignore */ }
}

// Show an OS notification if allowed. `tag` de-dupes repeats; clicking focuses
// the window and navigates to `url`.
export function showOsNotification(title, { body, tag, url } = {}) {
  try {
    if (!canNotify() || Notification.permission !== "granted" || isNotifMuted()) return;
    const n = new Notification(title, {
      body,
      tag,
      icon: "/favicon-192.png",
      badge: "/favicon-192.png",
      renotify: !!tag,
    });
    if (url) {
      n.onclick = () => {
        try { window.focus(); } catch { /* ignore */ }
        try { window.location.href = url; } catch { /* ignore */ }
        n.close();
      };
    }
  } catch { /* ignore */ }
}
